import React from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import './Hero.css';

const Hero = ({ data }) => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="home">
      <div className="hero-decorations">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="sparkle sparkle-1"><Sparkles size={16} /></div>
        <div className="sparkle sparkle-2"><Sparkles size={12} /></div>
        <div className="sparkle sparkle-3"><Sparkles size={14} /></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-text">
          <p className="hero-tagline">{data.tagline}</p>
          <h1 className="hero-title">{data.title}</h1>
          <p className="hero-subtitle">{data.subtitle}</p>
          <button className="hero-cta" onClick={scrollToContact}>
            {data.cta}
            <ArrowRight size={20} className="cta-icon" />
          </button>
        </div>
      </div>

      <div className="scroll-indicator">
        <div className="scroll-line"></div>
        <p>Scroll</p>
      </div>
    </section>
  );
};

export default Hero;
